import styled from "@emotion/styled"
import type { BreakpointValues } from "@porsche-design-system/components-react"
import { breakpoint } from "@porsche-design-system/components-react/emotion"
import type { HTMLAttributes, PropsWithChildren } from "react"
import { shouldForwardProp } from "src/common/shouldForwardProp"

export type GridItemSize = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12

interface GridItemProps extends PropsWithChildren, HTMLAttributes<HTMLDivElement> {
	size: BreakpointValues<GridItemSize> | GridItemSize
}

export const GridItem = ({ size, ...rest }: GridItemProps) => (
	<Wrapper $size={typeof size === "number" ? { base: size } : size} {...rest} />
)

const Wrapper = styled("div", { shouldForwardProp })<{ $size: BreakpointValues<GridItemSize> }>`
	grid-column: ${({ $size }) => ($size.base ? `span ${$size.base}` : undefined)};
	@media (min-width: ${breakpoint.xs}px) {
		grid-column: ${({ $size }) => ($size.xs ? `span ${$size.xs}` : undefined)};
	}
	@media (min-width: ${breakpoint.s}px) {
		grid-column: ${({ $size }) => ($size.s ? `span ${$size.s}` : undefined)};
	}
	@media (min-width: ${breakpoint.m}px) {
		grid-column: ${({ $size }) => ($size.m ? `span ${$size.m}` : undefined)};
	}
	@media (min-width: ${breakpoint.l}px) {
		grid-column: ${({ $size }) => ($size.l ? `span ${$size.l}` : undefined)};
	}
	@media (min-width: ${breakpoint.xl}px) {
		grid-column: ${({ $size }) => ($size.xl ? `span ${$size.xl}` : undefined)};
	}
	@media (min-width: ${breakpoint.xxl}px) {
		grid-column: ${({ $size }) => ($size.xxl ? `span ${$size.xxl}` : undefined)};
	}
`
